import { Action, Dispatch } from 'redux'
import { saveStoreGeoSearchConfirmAction } from 'reducks/confirm/actions'
import { StoreGeoSearch } from 'types/storeGeoSearch'

const saveStoreGeoSearchConfirm = (storeGeoSearch: StoreGeoSearch | undefined) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(saveStoreGeoSearchConfirmAction(storeGeoSearch))
  }
}

export default saveStoreGeoSearchConfirm
